import { HttpRequestStatus } from "../models/Http";

export const isComplete = (status: HttpRequestStatus) =>
  HttpRequestStatus.done === status;

export const isSent = (status: HttpRequestStatus) =>
  HttpRequestStatus.null !== status;
